var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._t("default",null,null,{ loading: _vm.loading, auth: _vm.auth })],2)
}
var staticRenderFns = []

export { render, staticRenderFns }